import service from '../axios/$axios'

export const login = (data) => service.post('/login', data)
export const getUserInfo = () => service.get('/user/info')
